<template>
  <div class="mb-5">
    <div class="row">
      <div class="col-2 p-0 m-0 card card-side-bar" v-if="selectedTab != 'feedbackEvaluation'">
        <h4 class="pl-3 mt-3 mb-4 tree-header">FeedBack</h4>
        <hr class="p-0 m-0 mt-4" />
        <div
          class="p-1"
          :class="showActiveTab(i)"
          @click="showActiveState(data.text)"
          @
          v-for="(data,i) in subheading"
          :key="i"
        >
          <span>
            <img class="mt-2" style="float: right; " alt src="@/assets/sidenav-icon.svg" />
            <p class="ml-3 mt-2 tree-header-name">{{data.text}}</p>
          </span>
          <hr class="p-0 m-0 mb-n1" />
        </div>
      </div>
      <div v-if="selectedTab == 'New'" class="col-10 mt-5">
        <div class="card mr-2">
          <div class="row">
            <div class="col-3 ml-5">
              <img class="feedback-img" alt src="@/assets/feedback-icon.jpg" />
            </div>
            <div class="col ml-5">
              <h3 class="header-text pt-4 pl-3 text-left">Experience Feedback</h3>
              <p class="header-sub-text pl-3 mt-2 text-left">
                We want to know about your experience, So Your feedback
                is very important to us. It helps us to improve our service
              </p>
            </div>
          </div>
        </div>
        <br />
        <div class="col-10 p-0 m-0 card p-3">
          <h4
            class="card-text text-left"
          >Enter the details of Project for which you want give your feedback</h4>
          <hr class="p-0 m-0" />
          <br />
          <div class="row">
            <div class="float-left text-left ml-4">
              <p class="source-sans-pro field-headings text-left p-0 m-0">Select One</p>
              <div class="d-inline-block" v-for="(data,index) in partnerCategory" :key="index">
                <w-button-input
                  :buttonText="data.text"
                  :buttonStyle="tabselectionstyle(index,data.text)"
                  @onButtonClick="getTabData(index)"
                />
              </div>
            </div>
            <div v-if="activeFirstTab" class="col-4">
              <b-form-group class="source-sans-pro field-headings text-left" label="Job Details">
                <w-dropDown
                  class="width-control-small"
                  :options="projectDetails"
                  @dropdownChange="getProjectDetails($event)"
                  :selected="projectNameValue"
                />
              </b-form-group>
            </div>
          </div>
          <div v-if="!activeFirstTab" class="row mt-2 pl-1">
            <div class="col-4">
              <b-form-group
                class="source-sans-pro field-headings text-left"
                label="Select category"
              >
                <w-dropDown
                  class="width-control-small"
                  :options="categoryOptions"
                  @dropdownChange="getCategoryOption($event)"
                  :selected="selectedCategory"
                />
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group class="source-sans-pro field-headings text-left" label="Job Details">
                <w-dropDown
                  class="width-control-small"
                  :options="projectDetails"
                  @dropdownChange="getProjectDetails($event)"
                  :selected="projectNameValue"
                  :disabled="!selectedCategory"
                />
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group
                class="source-sans-pro field-headings text-left"
                :label="selectedCategory == '2'?'PO Number':'WO Number'"
              >
                <w-dropDown
                  class="width-control-small"
                  :options="jobNumber"
                  @dropdownChange="getPODetails($event)"
                  :selected="jobNumberValue"
                  :disabled="!projectNameValue"
                />
              </b-form-group>
            </div>
          </div>
          <b-button
            @click="startFeedback()"
            class="col-3 mt-3 ml-auto submit-button mr-3"
          >Give Feedback &nbsp; &nbsp;</b-button>
        </div>
      </div>
      <div class="col-10" v-if="selectedTab == 'History'">
        <c-history
          v-if="selectedTab == 'History'"
          :currentTab="selectedTab"
          :companyCode="companycode"
          :vendorCode="vendorCodeValue"
          @navigateBack="successReponse($event)"
        />
      </div>
      <div class="col-10" v-if="selectedTab == 'Draft'">
        <c-draft
          v-if="selectedTab == 'Draft'"
          :currentTab="selectedTab"
          :companyCode="companycode"
          :vendorCode="vendorCodeValue"
          @navigateBack="successReponse($event)"
        />
      </div>
    </div>
    <div>
      <!-- {{jobNumberValue}},{{vendorCodeValue}},{{selectedJobCategory}} -->
      <!-- <c-evaluation
        v-if="selectedTab == 'feedbackEvaluation'"
        :poNumber="jobNumberValue"
        :vendorCode="vendorCodeValue"
        :jobCode="projectNameValue"
        :companyCode="companycode"
        :jobType="selectedJobCategory"
        :FeedbackStatus="'New'"
        @navigateBack="successReponse($event)"
      />-->
      <c-evaluation
        v-if="selectedTab == 'feedbackEvaluation'"
        :poNumber="jobNumberValue== '' ? 'General':jobNumberValue "
        :vendorCode="vendorCodeValue"
        :jobCode="projectNameValue"
        :jobDesc="projectNameDescription"
        :companyCode="companycode"
        :jobType="selectedJobCategory == '' ? 'GE':selectedJobCategory"
        :FeedbackStatus="'New'"
        @navigateBack="successReponse($event)"
      />
      <w-modal
        :trigger="triggerModal"
        :text="lastResponse"
        :title="modalTitle"
        :centered="true"
        :dontCloseWhenClickedOutside="true"
        :dontCloseWhenEscapePressed="true"
        :dontShowCloseIcon="true"
        :modalbuttonStyle="true"
        :showAlert="alertModal"
        :showSuccess="successModal"
        @eventClose="changeModalSuccess()"
      />
    </div>
  </div>
</template>

<script>
import DropDown from "../../widgets/DropDown";
import TextInput from "../../widgets/TextInput";
import multiSelect from "vue-multi-select";
import Radio from "../../widgets/Feedbackradio";
import partnerEvaluation from "../../components/partnerfeedback/partnerEvaluation";
import partnerHistory from "../../components/partnerfeedback/partnerfeedbackDetails";
import moment from "moment";
import { PartnerService } from "../../services/partnerService";
import ButtonInputVue from "../../widgets/ButtonInput.vue";
import widgetModal from "../../widgets/newModalWidget";
const partnerService = new PartnerService();
export default {
  components: {
    "c-evaluation": partnerEvaluation,
    "c-history": partnerHistory,
    "c-draft": partnerHistory,
    "w-dropDown": DropDown,
    "w-button-input": ButtonInputVue,
    "w-modal": widgetModal
  },
  created() {
    this.getPartnerDetails();

    this.selectedTab = "New";
  },

  data() {
    return {
      module: "financial",
      activeFirstTab: true,
      financialData: "",
      financialValue: [],
      companycode: "",
      activeNode: 1,
      selectedCategory: "",
      selectedJobCategory: "",
      jobNumberValue: "",
      financialStrength: "",
      financialOthers: "",
      financialmerge: "",
      projectNameValue: "",
      projectNameDescription: "",
      selectedTab: "",
      vendorCodeValue: "",
      triggerModal: false,
      lastResponse: "",
      successModal: false,
      alertModal: false,
      partnerCategory: [
        {
          text: "Projectwise"
        },
        {
          text: "Orderwise"
        }
      ],
      categoryOptions: [
        {
          text: "Select Partner",
          disabled: true
        }
      ],
      projectDetails: [
        {
          text: "Select Project",
          disabled: true
        }
      ],
      jobNumber: [
        {
          text: "Select Number",
          disabled: true
        }
      ],
      subheading: [
        {
          text: "New",
          value: 1
        },
        {
          text: "History",
          value: 2
        },
        {
          text: "Draft",
          value: 3
        }
      ]
    };
  },
  methods: {
    getPartnerDetails() {
      partnerService.getPartnerInfo().then(resp => {
        if (resp.response) {
          this.companycode = resp.response.currentCompanyCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
          this.vendorCodeValue = resp.response.vendorCode;
          this.getJobWiseDropDown();
        }
      });
    },
    successReponse(event) {
      this.selectedCategory = "";
      this.projectNameValue = "";
      this.jobNumberValue = "";
      if (event == "New") {
        this.activeNode = 1;
        this.selectedTab = "New";
        return;
      }
      if (event == "History") {
        this.activeNode = 2;
        this.selectedTab = "History";
        return;
      }
      if (event == "Draft") {
        this.activeNode = 3;
        this.selectedTab = "Draft";
        return;
      }
    },
    changeModalSuccess() {
      this.triggerModal = false;
      this.alertModal = false;
      this.successModal = false;
    },
    tabselectionstyle(event) {
      if (
        (0 === event && this.activeFirstTab == true) ||
        (1 === event && this.activeFirstTab == false)
      ) {
        return "requestListTabSelectionPartner";
      } else {
        return "defaulfRequestListTabSelectionPartner";
      }
    },
    getTabData(event) {
      this.selectedCategory = "";
      this.projectNameValue = "";
      this.jobNumberValue = "";
      if (event == 0 && this.activeFirstTab == false) {
        this.activeFirstTab = true;
        // this.getJobWiseDropDown();
      } else if (event == 1 && this.activeFirstTab == true) {
        this.activeFirstTab = false;
        this.getPartnerTypes();
      }
    },
    getJobWiseDropDown() {
      this.projectDetails = [];
      partnerService
        .getJobDropDownOrderWise(this.vendorCodeValue)
        .then(resp => {
          if (resp.response) {
            resp.response.vendor.forEach((item, index) => {
              this.projectDetails.push({
                text: item.jobdesc,
                value: item.jobCode
              });
            });
          }
        });
    },
    getPartnerTypes() {
      this.categoryOptions = [
        {
          text: "Select Partner",
          disabled: true
        }
      ];
      partnerService.getPartnertype(this.companycode).then(resp => {
        if (resp.response) {
          resp.response.forEach((item, index) => {
            if (item.status == "A") {
              this.categoryOptions.push({
                text: item.description,
                value: item.partnerTypeCode
              });
            }
          });
        }
      });
    },

    getCategoryOption(event) {
      this.selectedCategory = event;
      if (event == 2) {
        this.selectedJobCategory = "PO";
        this.getJobCategory("Po");
      } else {
        this.selectedJobCategory = "WO";
        this.getJobCategory("Wo");
      }
    },

    getJobCategory(category) {
      this.projectDetails = [];
      this.jobNumber = [];
      partnerService.getJobDropDownValues(category).then(resp => {
        if (resp.response) {
          if (resp.response.vendor.length > 0) {
            resp.response.vendor.forEach((item, index) => {
              this.projectDetails.push({
                text: item.jobdesc,
                value: item.jobCode
              });
            });
          }
        }
      });
    },
    getProjectDetails(event) {
      this.projectNameValue = event;
      this.projectDetails.forEach((data, index) => {
        if (this.projectNameValue == data.value) {
          var name = data.text.split("~");
          this.projectNameDescription = name[1];
        }
      });
      this.getOrderNumberValue(event);
    },
    getOrderNumberValue(event) {
      this.jobNumber = [];
      partnerService
        .getWorkorderDropDownValues(this.selectedJobCategory, event)
        .then(resp => {
          if (resp.response) {
            resp.response.ordersummary.forEach((item, index) => {
              this.jobNumber.push({
                text: item,
                value: item
              });
            });
          }
        });
    },
    getPODetails(event) {
      this.jobNumberValue = event;
    },
    showActiveState(value) {
      switch (value) {
        case "New":
          this.activeNode = 1;
          this.selectedTab = "New";
          break;
        case "History":
          this.activeNode = 2;
          this.selectedTab = "History";
          break;
        case "Draft":
          this.activeNode = 3;
          this.selectedTab = "Draft";
          break;
      }
    },
    showActiveTab(i) {
      if (i + 1 == this.activeNode) {
        return "sidebar-background-hover";
      }
    },
    startFeedback() {
      if (this.activeFirstTab == true) {
        if (this.projectNameValue) {
          this.selectedTab = "feedbackEvaluation";
        } else {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = "Please select the job details to give feedback";
        }
      } else {
        if (
          this.projectNameValue &&
          this.selectedCategory &&
          this.jobNumberValue
        ) {
          this.selectedTab = "feedbackEvaluation";
        } else {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = "Please fill all Details to give feedback";
        }
      }
    }
  }
};
</script>

<style>
.card-side-bar {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
  font-weight: 500;
  width: 50px !important;
  height: 850px !important;
  text-align: left;
}
.tree-header {
  opacity: 0.7;
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 22px;
  font-weight: bold;
}
.tree-header-name {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 16px !important;
  font-weight: bold;
}
.header-text {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 32px;
  font-weight: bold;
  color: #0e5d84;
}
.header-sub-text {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 20px;
  color: #484848;
  width: 55% !important;
}
.card-text {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 17px;
  font-weight: bold;
}
.sidebar-background:hover {
  color: #0c5e9d !important;
  background-color: #dfedf7 !important;
}
.feedback-img {
  width: 320px;
  height: 216px;
}
.submit-button {
  background-color: #0c5e9d;
  font-family: "Open Sans", sans-serif !important;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.sidebar-background-hover {
  color: #0c5e9d !important;
  background-color: #dfedf7 !important;
}
</style>

